import { ReactNode } from 'react';
import { useToggle } from 'usehooks-ts';

type ChildrenParams = {
	isLoaded: boolean;
	isError: boolean;
	setError: () => void;
	setLoaded: () => void;
};

type Props = {
	children: (params: ChildrenParams) => ReactNode;
	placeholder?: ReactNode;
	ignoreError?: boolean;
};

const ImageOnLoadRPC = ({ children, placeholder = null, ignoreError = false }: Props) => {
	const [isError, setError] = useToggle(false);
	const [isLoaded, setLoaded] = useToggle(false);

	if (isError && !ignoreError) return placeholder;

	return children({
		isLoaded,
		isError,
		setError,
		setLoaded
	});
};

export default ImageOnLoadRPC;
